// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"95cd38c8","456":"2eeeb622","656":"23c26a4e","756":"348dd0d4","968":"3629b93c"}[chunkId] + ".chunk.js";
};